import { useMemo } from "react";
import styles from "./ReportSummary.module.css";
import { EVALUATION_VERDICTS } from "@constants/evaluationConstants";

interface ReportSummaryProps {
  questions: any[];
}

function ReportSummary({ questions }: ReportSummaryProps) {
  const getEvaluationResult = (q: any) =>
    q?.previous_evaluation_result ?? q?.current_evaluation ?? null;

  const grandTotal = useMemo(() => {
    return questions.reduce(
      (sum, q) => sum + parseFloat(getEvaluationResult(q)?.awarded_marks ?? 0),
      0
    );
  }, [questions]);

  const maxTotal = useMemo(() => {
    return questions.reduce((sum, q) => sum + (q?.max_marks ?? 0), 0);
  }, [questions]);

  const attemptedQuestions = useMemo(() => {
    return questions.reduce((sum, q) => {
      const result = getEvaluationResult(q);
      return (
        sum +
        (result && result.attempt_status !== EVALUATION_VERDICTS.UNATTEMPTED
          ? 1
          : 0)
      );
    }, 0);
  }, [questions]);

  const checkEvaluated = (item: any) => {
    const result = getEvaluationResult(item);
    return result != null && result.attempt_status !== EVALUATION_VERDICTS.UNATTEMPTED;
  };

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <p>Marks by Question based on the L1 Evaluation</p>
      </div>
      <div className={styles.marksGrid}>
        {questions.map((item, index) => {
          const result = getEvaluationResult(item);
          return (
            <div
              key={index}
              className={`${styles.marksCard} ${
                checkEvaluated(item) ? "" : styles.notEvaluated
              }`}
            >
              <span>Q{index + 1}</span>
              {result &&
              result.attempt_status !== EVALUATION_VERDICTS.UNATTEMPTED ? (
                <div className={styles.marks}>
                  <span className={styles.awardedMarks}>
                    {result.awarded_marks}{" "}
                  </span>
                  <span>/</span>
                  <span> {item.max_marks}</span>
                </div>
              ) : (
                <span>-</span>
              )}
            </div>
          );
        })}
      </div>
      <div className={styles.underLine}></div>
      <div className={styles.totalMarksContainer}>
        <div className={styles.totalMarksHeading}>
          <p>Total Marks</p>
          <span>
            {attemptedQuestions} of {questions.length} questions attempted
          </span>
        </div>
        <div className={styles.totalMarksValue}>
          <span className={styles.totalAwardedMarks}>{grandTotal.toFixed(2)}</span>
          <span>/</span>
          <span>{maxTotal}</span>
        </div>
      </div>
    </div>
  );
}

export default ReportSummary;
